module.exports = __webpack_public_path__ + "img/delivery.bcb0ba53.svg";